export { SkuDetailPage } from './view/sku-detail-page';
